import { FiUpload } from 'react-icons/fi'
import Button from 'react-bootstrap/Button'
import Spinner from 'react-bootstrap/Spinner'

const SaveButton = (props) => {
    return (
        <Button
            size="lg"
            variant={props.variant ? props.variant : "primary"}
            className={props.className}
            disabled={props.isSubmitting}
            onClick={props.onClick}
        >
            {props.isSubmitting
                ? <Spinner animation="border" size="sm" variant="secondary" className="mx-5" />
                : <>
                    {!props.hideIcon && <FiUpload />} {props.title}
                </>
            }
        </Button>
    )
}

export default SaveButton